<template>
  <div class="card modal-card">
    <header class="bandeau-modal card-header"></header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('detailEmplacement.popupDeplacerDispositif.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="modal-card-body">
      <error-msg-component
        :error="error"
        :messages="messages"
        :champsVide="champsVide"
        :messagesChampsVide="messagesChampsVide"
        @close="error = $event"
        title="general.problemOccurred"
        withEmplyFields
      />
      <div class="">
        <div class="card mgb-20px">
          <header class="header-card">
            <p> {{ $t('detailEmplacement.popupDeplacerDispositif.dispositif') }} </p>
          </header>
          <div class="card-content">
            <div class="columns">
              <div class="column is-3">
                <b-field :label="$t('detailEmplacement.popupDeplacerDispositif.code')"
                  custom-class="has-text-weight-normal is-marginless">
                  <span class="has-text-weight-bold">
                    {{ dispositif.code }}
                  </span>
                </b-field>
              </div>
              <div class="column">
                <b-field :label="$t('detailEmplacement.popupDeplacerDispositif.adresse')"
                  custom-class="has-text-weight-normal is-marginless">
                  <span class="has-text-weight-bold">
                    {{getAdresse(dispositif.adresse)}}
                  </span>
                </b-field>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-narrow is-align-content-center">
            <span>
              {{ $t('detailEmplacement.popupDeplacerDispositif.deplacerVers') }}
            </span>
          </div>
          <div class="column">
            <b-field>
              <b-autocomplete
                :value="search"
                :data="filteredEmplacements"
                :loading="isFetching"
                :placeholder="$t('detailEmplacement.popupDeplacerDispositif.placeholder')"
                :open-on-focus="false"
                append-to-body
                @input="getFilteredEmplacement"
                @select="selectedEmplacement"
                field="codeAvecLibelle"
                icon="magnify">
                <template slot-scope="props">
                  <p>
                    {{ props.option.codeAvecLibelle }}
                  </p>
                </template>
                <template slot="empty">
                  <div v-if="!isFetching">
                    {{$t('general.autocomplete.noRslt')}}
                  </div>
                  <div v-else>
                    {{$t('general.autocomplete.search')}}
                  </div>
                </template>
              </b-autocomplete>
            </b-field>
          </div>
        </div>
        <div class="card mgt-20px" v-if="emplacementVers">
          <header class="header-card">
            <p> {{ $t('detailEmplacement.popupDeplacerDispositif.emplacement') }} </p>
          </header>
          <div class="card-content">
            <div class="columns is-multiline">
              <div class="column is-3">
                <b-field :label="$t('detailEmplacement.popupDeplacerDispositif.emplacementCode')"
                  custom-class="has-text-weight-normal is-marginless">
                  <span class="has-text-weight-bold">
                    {{ emplacementVers.code }}
                  </span>
                </b-field>
              </div>
              <div class="column is-3">
                <b-field :label="$t('detailEmplacement.popupDeplacerDispositif.emplacementLibelle')"
                  custom-class="has-text-weight-normal is-marginless">
                  <span class="has-text-weight-bold">
                    {{emplacementVers.libelle}}
                  </span>
                </b-field>
              </div>
              <div class="column is-3">
                <b-field
                  :label="$t('detailEmplacement.popupDeplacerDispositif.emplacementDescription')"
                  custom-class="has-text-weight-normal is-marginless">
                  <span class="has-text-weight-bold">
                    {{emplacementVers.description}}
                  </span>
                </b-field>
              </div>
              <div class="column is-3">
                <b-field :label="$t('detailEmplacement.popupDeplacerDispositif.adresse')"
                  custom-class="has-text-weight-normal is-marginless">
                  <span class="has-text-weight-bold">
                    {{getAdresse(emplacementVers.adresseCadastrale)}}
                  </span>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="buttons mgt-20px">
        <qd-button
          @click="$parent.close()"
          type="is-light"
          class="btn-modal-annuler">
          {{$t('general.button.cancel')}}
        </qd-button>
        <qd-button
          @click="popUpPrevention = true"
          :disabled="!emplacementVers"
          class="button is-addOrEdit">
          {{$t('detailEmplacement.popupDeplacerDispositif.deplacer')}}
        </qd-button>
      </footer>
    </div>
    <b-modal
      v-model="popUpPrevention"
      :width="800"
      has-modal-card
      class="modal">
      <popUpPrevention
        :messHeader="$t('detailEmplacement.popupDeplacerDispositif.titlePopUpPrevenvention')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpPrevention = false"
        @yes="appliquer"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import { deplacerAsync } from '@/api/gabed/dispositif';
import { getAll } from '@/api/gabed/emplacement';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import popUpPrevention from '@/components/general/popUpPrevention';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/gabed/dispositif/translatorDeplacementDispositif';
import validation from '@/services/gabed/dispositif/validationDeplacementDispositif';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'popupDeplacementDispositif',
  components: {
    errorMsgComponent,
    popUpPrevention,
  },
  props: {
    dispositif: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      popUpPrevention: false,
      emplacementVers: null,
      filteredEmplacements: [],
      isFetching: false,
      search: null,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    getAdresse(adresse) {
      return adressFullStringGetter(adresse);
    },
    getFilteredEmplacement: debounce(async function itemsData(text) {
      if (text === this.search) return;
      try {
        this.search = text;
        this.isFetching = true;
        const emplacements = (await getAll({
          query: {
            auto: this.search,
            societeId: this.societeActiveId,
            actif: true,
          },
        })).data.result.items;
        emplacements.map((el) => {
          el.codeAvecLibelle = [el.code, el.libelle].filter(Boolean).join(' ');
          return el;
        });
        this.filteredEmplacements = emplacements;
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw e;
      }
    }, 500),
    selectedEmplacement(val) {
      if (!val) return;
      this.search = val.code;
      this.emplacementVers = val;
    },
    async appliquer() {
      const loadingComponent = this.$buefy.loading.open();
      this.error = false;
      this.popUpPrevention = false;
      this.messages = [];
      this.champsVide = [];
      this.messagesChampsVide = [];
      try {
        await deplacerAsync({
          dispositifId: this.dispositif.id,
          emplacementId: this.emplacementVers.id,
        });
        messageSuccess(this.$i18n.t('detailEmplacement.popupDeplacerDispositif.success'));
        this.$emit('deplacer');
        this.$parent.close();
      } catch (e) {
        if (e.response?.data?.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          validation(e.response, this.messages);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
  },
};
</script>
